import styled, { css } from 'styled-components';
import { HeroBackgroundImage } from './background-image';
import { HeroBackgroundOverlay } from './overlay';
import { themeToken } from 'src/components/common/cpds/utils/cpds-utils';
import { cpdsMediaQueryVals } from 'src/components/common/cpds/token/shared/common/common.token';

const V3HeroModuleComponent = styled.div.attrs({
  className: 'v3-hero-module-component',
})`
  .v3-hero-bg-video {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 1;
    object-fit: cover;
  }
`;

const V3HeroBgComponentWrapper = styled.div.attrs({
  className: 'v3-hero-module-bg-compoent-wrapper',
})`
  position: absolute;
  width: 100%;
  height: 100%;
`;

const V3HeroFgComponentWrapper = styled.div.attrs({
  className: 'v3-hero-module-fg-compoent-wrapper',
})`
  ${({
    theme: {
      styles: { cpds },
    },
    props,
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    return css`
      position: absolute;
      width: 100%;
      height: 100%;
      z-index: 2;
      transform: translateX(-50%);
      left: 50%;
    `;
  }}
`;

export {
  V3HeroModuleComponent,
  V3HeroBgComponentWrapper,
  V3HeroFgComponentWrapper,
  HeroBackgroundImage,
  HeroBackgroundOverlay,
};
